export default __webpack_public_path__ + "static/media/IconOrg.84c5717b.svg";